"use client";

import { IcoGrade, IconContactPhoneHomepage } from "@repo/assets/images";
import { ContactForm } from "@repo/components";
import { getStrapiMedia } from "@repo/lib/utils";
import { MotionContainer } from "@repo/ui";
import { motion, useInView, useScroll, useTransform } from "framer-motion";
import { useTranslations } from "next-intl";
import { useEffect, useRef, useState } from "react";
const LazyBackgroundImage = ({
  src
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    margin: "200px"
  });
  const [shouldLoad, setShouldLoad] = useState(false);
  useEffect(() => {
    if (isInView) {
      setShouldLoad(true);
    }
  }, [isInView]);
  return <div ref={ref} className="size-full bg-cover bg-center bg-no-repeat" style={{
    backgroundImage: shouldLoad ? `url(${src})` : "none"
  }} data-sentry-component="LazyBackgroundImage" data-sentry-source-file="ContactUs.jsx" />;
};
const ContactUs = ({
  data
}) => {
  const t = useTranslations("Common");
  const {
    tagLine,
    phoneNumber,
    media
  } = data;
  const container = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: container,
    offset: ["start end", "end start"]
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-80%", "40%"]);
  return <section className="bg-supportiveBlack overflow-hidden md:px-0" data-sentry-component="ContactUs" data-sentry-source-file="ContactUs.jsx">
      <div className="absolute h-[650px] w-full overflow-hidden md:h-[450px]">
        {media?.file?.url && <motion.div ref={container} style={{
        y
      }} className="absolute inset-0 h-[150%]">
            <LazyBackgroundImage src={getStrapiMedia(media.file.url)} />
          </motion.div>}
      </div>

      <div className="relative">
        <div className="relative inset-x-0 z-10 mx-auto max-w-[870px] px-4 pt-10 md:pt-16">
          <div className="md:flex md:space-x-32 md:rtl:space-x-reverse">
            <MotionContainer preset="fadeRight" delay={0.3} data-sentry-element="MotionContainer" data-sentry-source-file="ContactUs.jsx">
              <div>
                <div className="flex justify-center space-x-1 md:justify-start rtl:space-x-reverse">
                  {[...Array(5)].map((_, index) => <IcoGrade key={index} />)}
                </div>
                {tagLine && <p className="font-heading rtl:font-arabic py-6 text-center text-sm font-medium text-white md:text-start md:text-xl">
                    {tagLine}
                  </p>}
                {phoneNumber && <div className="flex items-center justify-center space-x-3 text-white md:justify-start rtl:space-x-reverse">
                    <IconContactPhoneHomepage />
                    <span className="block">
                      <span className="block text-sm font-semibold">
                        {t("Contact_Us")}
                      </span>
                      <span className="text-base font-bold">{phoneNumber}</span>
                    </span>
                  </div>}
              </div>
            </MotionContainer>
            <div className="w-full pt-6 md:pt-0">
              <div className="bg-supportiveDarkYellow z-10 px-4 pt-4 md:p-10">
                <h4 className="border-supportiveDarkGray font-heading text-supportiveBlack rtl:font-arabic mb-4 border-b pb-4 text-xl font-medium">
                  {t("Contact_Us_For_Assistance")}
                </h4>
                <ContactForm isHomepage={true} data-sentry-element="ContactForm" data-sentry-source-file="ContactUs.jsx" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default ContactUs;